import { compose, context } from 'msw';
// const IS_NODE_PROCESS = determineInAnyWayYouSeeFit();

export function delay() {
  return compose(
    context.delay(parseInt(import.meta.env.VITE_APP_MOCK_DELAY)) ?? 0
  );
}
